module.exports = __webpack_public_path__ + "media/images/FAQ-1-82ac08d4be7e1b2c12e1316c8de044d7.jpeg";